import { isUndefined } from 'lodash';
// eslint-disable-next-line import-whitelist -- needed for both core and content
import { getOutputByName } from '../../../../../../core/h3ml/dsl/sensor-fusion/sensor-fusion-output.utils';
import { isOrthographicVideoOutput } from '../../../../../../cross-team-shared/misc-utils/output-utils';
import { getOrThrow } from '../../../../../../cross-team-shared/misc-utils/strict-record';
import { Point3D } from '../../../../../../team-apis/otterdam/answers/shape-typings';
import { PointCloudContentState } from '../../../../../state/point-cloud-content-state';
import { getSensorLocation } from '../../../../../utils/location-utils';
import { CloudShaderMaterial } from '../../../cloud-shader-material';

export interface RegionOfInterestUniforms {
  distance: number;
  sensorLocation: Point3D;
}

export const regionOfInterestUniforms = `
  struct RegionOfInterestUniforms {
    float distance;
    vec3 sensorLocation;
  };
`;

export const regionOfInterest = `
  bool isRegionOfInterestEnabled() {
    float roiDistance = color.regionOfInterest.distance;
    return roiDistance >= 0.0;
  }

  bool isPointWithinRegionOfInterest() {
    vec3 sensorLocation = color.regionOfInterest.sensorLocation;
    float roiDistance = color.regionOfInterest.distance;
    float pointDistance = length(position - sensorLocation);
    return pointDistance < roiDistance;
  }
`;

export function setRegionOfInterestUniforms(
  material: CloudShaderMaterial,
  state?: PointCloudContentState,
) {
  let distance: number;
  let sensorLocation: Point3D;

  if (state) {
    distance = getRegionOfInterestDistance(state);
    sensorLocation = getSensorLocation(state);
  } else {
    distance = -1;
    sensorLocation = [0, 0, 0];
  }

  material.setColorUniform('regionOfInterest', { distance, sensorLocation });
}

function getRegionOfInterestDistance(state: PointCloudContentState) {
  const { enabled, useForAllCameras, distanceForAlCameras, distancePerCamera } =
    state.regionOfInterestSettings;
  const { splitViewOutputName, project } = state;

  if (!enabled) {
    return -1;
  }

  if (useForAllCameras || isUndefined(splitViewOutputName)) {
    return distanceForAlCameras;
  }

  const splitViewOutput = getOutputByName(project, splitViewOutputName);
  if (isOrthographicVideoOutput(splitViewOutput)) {
    return -1;
  }

  return getOrThrow(distancePerCamera, splitViewOutputName);
}
